import { useTranslation } from 'react-i18next';

import { OUTLINED } from 'features/common/components/Button/constants';
import { StickyBtnContainerProps } from '../../types';

import { StickyDiv, FormButton } from '../../ManageEmailCampaign.styles';

export const StickyBtnContainer = ({
	handleClick,
	isLargeScreen,
	isPunchup = false,
}: StickyBtnContainerProps & { isPunchup?: boolean }) => {
	const { t } = useTranslation();

	return (
		<>
			{!isLargeScreen && (
				<StickyDiv isPunchup={isPunchup}>
					<FormButton
						category={OUTLINED}
						onClick={() => handleClick({ status: 'DRAFT' })}
						text={t('marketing-campaignForm-saveDraft') + ' 3'}
						type="submit"
						isPunchup={isPunchup}
					/>
					<FormButton
						text={t('button-send')}
						type="submit"
						onClick={() => handleClick({ status: 'CREATED' })}
						isPunchup={isPunchup}
					/>
				</StickyDiv>
			)}
		</>
	);
};
